<button
  mat-icon-button
  [matMenuTriggerFor]="userMenu"
  aria-label="Menu do usuário"
>
  <nx-user-avatar [fotoBase64]="userFotoBase64()" [nome]="userName()" size="sm" />
</button>

<mat-menu #userMenu="matMenu" class="nexus-user-menu">
  <div class="px-4 pb-2 border-b">
    <div class="font-medium">{{ userPosto() }} {{ userNomeGuerra() }}</div>
    <div class="text-xs text-pmdf-muted-55">{{ userUnit() }}</div>
  </div>
  <button mat-menu-item [routerLink]="'/perfil'">
    <mat-icon class="icon-lg">account_circle</mat-icon>
    <span>Meu Perfil</span>
  </button>

  <!-- Toggle de tema — sempre visível, sem depender de feature flag -->
  <button mat-menu-item (click)="themeService.toggle(); $event.stopPropagation()">
    <mat-icon class="icon-lg">{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
    <span>{{ themeService.isDark() ? 'Modo Claro' : 'Modo Escuro' }}</span>
  </button>

  @if (flagService.isEnabled('configuracoes')) {
    <button mat-menu-item [routerLink]="'/config'">
      <mat-icon class="icon-lg">settings</mat-icon>
      <span>Configurações</span>
    </button>
  }
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="onLogout()" class="mt-0 pt-0">
    <mat-icon class="text-pmdf-danger icon-lg">logout</mat-icon>
    <span class="text-pmdf-danger">Sair</span>
  </button>
</mat-menu>
